









































































































import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Component } from '@niknevis/vue-modules'
import Vue from 'vue'
import {
  AdminContentItemSendToCompletedUseCase
} from '@/modules/content-item/use-cases/admin/admin-content-item-send-to-completed.use-case'
import { ContentItemSendToCompletedRequestModel } from '@/modules/content-item/models/content-item-request.model'
import {
  AdminContentItemGetDataForCompleteUseCase
} from '@/modules/content-item/use-cases/admin/admin-content-item-get-data-for-complete.use-case'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import { ContentItemGetDataForCompleteResourceModel } from '@/modules/content-item/models/content-item-resource.model'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'

@Component({
  components: {
    AdminUserInfoButton,
    TabularHeader,
    BaseButton,
    Toggle,
    Modal,
    CurrencyInput
  }
})
export default class AdminContentItemSendToCompleted extends Vue {
  constructor(
    protected readonly makeCompletedUC: AdminContentItemSendToCompletedUseCase,
    protected readonly getDataForCompleteUC: AdminContentItemGetDataForCompleteUseCase
  ) {
    super()
  }

  requestData: Omit<ContentItemSendToCompletedRequestModel, 'status'> = {
    update_writer_share: false,
    writer_share: 0,
    notify_to_user: true
  }

  @Prop({ required: true }) id!: number
  @Prop({ default: 'تکمیل کردن' }) label?: string

  showDialog = false

  showModal() {
    this.fetchGetDataForComplete()
  }

  protected get tabularColumns() {
    return [
      {
        name: 'writer',
        title: 'نویسنده',
        value: 'ندارد'
      },
      {
        name: 'word_rate',
        title: 'نرخ نویسنده',
        value: '0 هر کلمه'
      },
      {
        name: 'payable',
        title: 'پرداختی برای محتوا',
        value: ''
      }
    ]
  }

  get completeData(): ContentItemGetDataForCompleteResourceModel {
    return this.getDataForCompleteUC.data
  }

  initRequestData() {
    this.requestData.update_writer_share = this.completeData.update_writer_share
    this.requestData.writer_share = this.completeData.writer_share
  }

  fetchGetDataForComplete() {
    this.getDataForCompleteUC.execute(this.id)
      .on('success', () => {
        this.initRequestData()
        this.showDialog = true
      })
  }

  makeCompleted() {
    this.makeCompletedUC.execute(this.id, this.requestData)
      .then(() => {
        if (this.makeCompletedUC.isSuccess) {
          this.showDialog = false
        }
      })
  }
}
